import React from 'react';

const Content = () => {
    return null;
};

export default Content;
